<template>
    <div class="">
        <div class="headline mx-auto">
            <div class="headline-text position-relative text-uppercase fs-12 mx-auto">CAT-UXO COMMERCIAL MEMBERS</div>
        </div>

        <div class="container ad-container mx-auto p-75">
            <ul class="d-flex flex-wrap justify-content-center mx--12px">
                <li v-for="ad in adsToDisplay" class="card-wrapper m-12px">
                    <cat-uxo-ad-template :ad="ad"/>
                </li>
                <li v-if="placeholders"
                    v-for="i in placeholders"
                    class="position-relative card-wrapper placeholder m-12px fs-12 text-uppercase d-flex justify-content-center align-items-center"
                    style="background-color: #FFFFFF;"
                >

                    <img src="/img/sizing@16x8.svg" alt="" class="sizing-image">
                    <a :href="advertiseHere" class="sizing-image-overlay bg-white d-flex align-items-center justify-content-center">
                        <span class="">advertise here</span>
                    </a>

                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    import AdTemplate from "./AdTemplate";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "LinearAds",
        components: {
            AdTemplate,
        },
        data() {
            return{
                maxAds: 4,
                storageKey: 'cat_uxo_viewed_ads',

                viewedAdsStorage: null,
                adsToDisplay: null,
            }
        },

        computed: {
            ...mapGetters('adverts', [
                'fetchingAds',
                'ads',
            ]),

            placeholders() {

                if (this.ads.length >= 4) {
                    return false;
                }

                return this.maxAds - this.ads.length;
            },
            origin() {
                return window.location.origin;
            },
            advertiseHere() {
                return `${this.origin}/advertisement/`;
            },

            unseenAds() {
                return this.ads.filter( ad => ! this.viewedAdsStorage.includes(ad.id) );
            },

            currentlyViewedAdIds() {
                return this.adsToDisplay ? this.adsToDisplay.map( ad => ad.id ) : [];
            }

        },
        watch: {
            ads: {
                deep: true,
                handler: function (val) {
                    if (val) {
                        console.log('ads loaded');

                        this.viewedAdsStorage = this.getStorage();

                        console.log('storage', this.viewedAdsStorage);

                        if (! this.viewedAdsStorage) {
                            this.createStorage();
                        } else {
                            this.updateStorage();
                        }
                    }
                }
            }
        },

        created() {
            this.fetchAds().then( (data) => {
                console.log(data)
            });
        },

        methods: {
            ...mapActions('adverts', [
                'fetchAds',
            ]),

            createStorage() {
                localStorage.setItem(this.storageKey, JSON.stringify(this.currentlyViewedAdIds));
                this.viewedAdsStorage = this.getStorage();

                this.adsToDisplay = this.ads.length > this.maxAds
                    ? this.ads.slice(0, this.maxAds)
                    : this.ads;
            },

            updateStorage() {
                console.log('update');
                let unseenCount = this.unseenAds.length;

                if (unseenCount < this.maxAds) {
                    let emptySlots = this.maxAds - unseenCount;
                    let repeatedAds = this.viewedAdsStorage.slice(0, emptySlots);

                    let repeatedAdsObject = this.ads.filter(item => repeatedAds.includes(item.id))
                    let lastBatch = this.unseenAds.concat(repeatedAdsObject);

                    localStorage.setItem(this.storageKey, JSON.stringify(lastBatch.map(item => item.id)));
                    this.viewedAdsStorage = this.getStorage();

                    this.adsToDisplay = lastBatch;
                } else {
                    this.adsToDisplay = this.unseenAds.length > this.maxAds
                        ? this.unseenAds.slice(0, this.maxAds)
                        : this.unseenAds;

                    let viewed = this.viewedAdsStorage;
                    localStorage.setItem(this.storageKey, JSON.stringify(viewed.concat(this.currentlyViewedAdIds)));
                    this.viewedAdsStorage = this.getStorage();
                }
            },

            getStorage() {
                return JSON.parse(localStorage.getItem(this.storageKey));
            },
        }

    }
</script>

<style lang="scss" scoped>
    .headline{
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        position: relative;
    }
    .headline-text{
        color: #C4C0C0;
        background-color: #FBFBFB;
        position: relative;
        display: inline-block;
        width: auto;
        z-index: 3;
        padding: 0 4px;
    }
    .headline:after{
        content: "";
        width: 100%;
        position: absolute;
        left:0;
        top: 50%;
        z-index: 1;
        border-bottom: solid 1px #C4C0C0;
    }

    .card-wrapper {
        width: 100%;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.03);
        border-radius: 6px;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        margin: 0 12px 24px 12px;
    }
    .placeholder a{
        color: $c-blue-pale;
        text-align: center;
    }

    @media (max-width: 767px){
        .card-wrapper {
            width: calc(50% - 24px);
        }
    }
    @media (max-width: 532px) {
        .card-wrapper {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/StackedAds.vue